import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Bundle, ScheduleLineGroup } from '@paragon/contract-library';

interface ScheduleLineGroupsState {
  [scheduleLineGroupGuid: string]: ScheduleLineGroup;
}

const initialState: ScheduleLineGroupsState = {};

const scheduleLineGroupsSlice = createSlice({
  name: 'scheduleLineGroups',
  initialState,
  reducers: {
    scheduleLineGroupsLoaded: (state, action: PayloadAction<readonly ScheduleLineGroup[]>) => {
      for (const scheduleLineGroup of action.payload) {
        state[scheduleLineGroup.guid] = castDraft(scheduleLineGroup);
      }
    },
    scheduleLineGroupCreated: (state, action: PayloadAction<ScheduleLineGroup>) => {
      state[action.payload.guid] = action.payload;
    },
    scheduleLineGroupDeleted: (
      state,
      action: PayloadAction<{ scheduleLineGroupGuid: string; updatedBundles: readonly Bundle[] }>,
    ) => {
      delete state[action.payload.scheduleLineGroupGuid];
    },
  },
});

export const { scheduleLineGroupsLoaded, scheduleLineGroupCreated, scheduleLineGroupDeleted } =
  scheduleLineGroupsSlice.actions;
export const scheduleLineGroups = scheduleLineGroupsSlice.reducer;
